import React from "react";
import "./Strategies.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faBullseye,
  faLayerGroup,
  faPenRuler,
  faGear,
  faArrowTrendUp,
} from "@fortawesome/free-solid-svg-icons";

const strategyItems = [
  {
    icon: faChartLine,
    title: "Research & Analysis",
    description:
      "We start with your business, audience, and current performance so we can spot real opportunities—not guess.",
  },
  {
    icon: faBullseye,
    title: "Positioning & Messaging",
    description:
      "We sharpen how your brand speaks so visitors quickly get your value and feel confident choosing you.",
  },
  {
    icon: faLayerGroup,
    title: "Structured Growth Plan",
    description:
      "We design a clear system that ties together traffic, content, and conversions so everything works toward one goal.",
  },
  {
    icon: faPenRuler,
    title: "Experience & Content Design",
    description:
      "Pages, visuals, and copy are built to guide users, reduce friction, and answer questions before they ask.",
  },
  {
    icon: faGear,
    title: "Automation & Tools",
    description:
      "We add forms, tracking, and follow-ups so every lead is captured, tracked, and handled consistently.",
  },
  {
    icon: faArrowTrendUp,
    title: "Testing & Improvement",
    description:
      "After launch we monitor performance and keep improving so results compound over time.",
  },
];

const Strategies = () => {
  return (
    <section className="sg-about" aria-label="Our strategy">
      <div className="sg-about-wrap">
        <header className="sg-about-head">
          <span className="sg-about-kicker">Our strategy</span>
          <h2>Structured, clear, and focused on results</h2>
          <p>
            We follow a process that cuts confusion, aligns decisions with your goals, and builds long-term growth—not one-off fixes.
          </p>
        </header>

        <div className="sg-about-grid">
          {strategyItems.map((item) => (
            <article className="sg-about-card" key={item.title}>
              <div className="sg-about-icon">
                <FontAwesomeIcon icon={item.icon} />
              </div>

              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strategies;
